import React, { Component } from 'react';
import './ForgotPassword.css';

import { withFirebase } from '../firebase';

const INITIAL_STATE = {
  email: '',
  error: null,
  isOpen: false,
};

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    const { email } = this.state;

    this.props.firebase
      .doPasswordReset(email)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.onClose();
      })
      .catch(error => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    if (!this.props.show) {
      return null;
    }

    const { email, error } = this.state;

    return (
      <div className="ForgotPassword">
        <div className="ForgotPassword-modal">
          <h1 className="ForgotPassword-title">Reset password</h1>
          <h2 className="ForgotPassword-subtitle">
            Please enter your email below
          </h2>
          <form onSubmit={this.onSubmit} className="ForgotPassword-form">
            <input
              name="email"
              value={email}
              onChange={this.onChange}
              type="email"
              placeholder="Email"
              required
            />
            {error && <p>{error.message}</p>}
            <div className="ForgotPassword-form--btn-container">
              <button type="submit">Submit</button>
              <span>or</span>
              <button
                onClick={this.props.onClose}
                style={{ backgroundColor: '#123776' }}
                type="button"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withFirebase(ForgotPassword);
